import styled from 'styled-components'
import LevelContainer from 'components/LevelContainer'

export const ActionBar = styled(LevelContainer)`
  background-color: ${props => props.theme.colors.dark1};
  width: 100%;
  padding: 8px 16px;
`